import React, { useEffect, useRef } from 'react';

const PptxSourceTextBlock = ({ block }) => {
    const containerRef = useRef(null);

    // Effect to update the content display when blocks change
    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.innerHTML = ''; // Clear previous content

            block.forEach(segment => {
                const span = document.createElement('span');
                span.textContent = segment.text;
                span.dataset.id = segment.id;
                span.dataset.slide = segment.slide;
                span.dataset.shapeId = segment.shapeId;
                span.dataset.textId = segment.textId;

                span.style.margin = '0 2px';
                span.style.borderRadius = '4px';
                span.style.display = 'inline';

                if (segment.style) {
                    span.className = segment.style;
                }

                containerRef.current.appendChild(span);
            });
        }
    }, [block]);

    return (
        <div
            ref={containerRef}
            className="p-1"
            style={{
                width: '100%',
                overflow: 'hidden',
                textAlign: 'start',
                fontSize: '14px',
                lineHeight: '1.5',
                borderRadius: '5px',
            }}
        />
    );
};

export default PptxSourceTextBlock;